import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Modal } from 'antd';
import { Flex, Box, Image } from 'atoms';
import { RejectionList } from 'components/pages/collection/rejection-notification';
import enlargeIcon from 'assets/enlarge-icon.svg';

export default function RejectionDetailsCard({ invoices }) {
	const [visible, setVisible] = useState(false);
	/**
	 * If invoices not containing any rejection return null
	 */
	const isValid = invoices?.some((item) => item?.rejectNotification?.length > 0);

	if (!isValid) {
		return null;
	}

	function handleViewMore() {
		console.log('handleViewMore');
		setVisible(true);
	}

	return (
		<Box position="relative">
			{console.log('invoices', invoices)}
			<RejectionList invoices={invoices} isModel={false} />
			<ViewMore onClick={handleViewMore}>
				<Image src={enlargeIcon} alt="view more" height={24} width={24} />
			</ViewMore>
			<Modal
				style={{ position: 'relative' }}
				width={350}
				footer={null}
				visible={visible}
				closable={false}
				centered
			>
				<RejectionList invoices={invoices} isModel />
				<Flex justifyContent="center">
					<Close onClick={() => setVisible(false)}>Close</Close>
				</Flex>
			</Modal>
		</Box>
	);
}

const ViewMore = styled(Box)`
	position: absolute;
	top: 5px;
	right: 5px;
	z-index: 1000;
	cursor: pointer;
`;

const Close = styled(Box)`
	margin-top: 1rem;
	font-size: 16px;
	color: ${(props) => props.theme.colors.primary};
	cursor: pointer;
`;

RejectionDetailsCard.propTypes = {
	invoices: PropTypes.array,
};
